// ===============================
// Saikyou Belt Collection - JavaScript
// ===============================

// ラジオボタンによるタブ切り替えはCSSで実装済み
// このファイルには追加のインタラクティブ機能を記述

(function() {
  'use strict';

  // DOMContentLoaded イベント
  document.addEventListener('DOMContentLoaded', function() {
    
    // スムーススクロール
    initSmoothScroll();
    
    // 画像の遅延読み込み対応
    initLazyLoading();
    
  });

  /**
   * スムーススクロール機能
   */
  function initSmoothScroll() {
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        // # のみの場合はページトップへ
        if (href === '#' || href === '#!') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        
        // IDが存在する場合
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const offsetTop = target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: offsetTop - 80, // ヘッダー分のオフセット
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /**
   * 画像の遅延読み込み
   */
  function initLazyLoading() {
    const images = document.querySelectorAll('img[loading="lazy"]');
    
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
            }
            observer.unobserve(img);
          }
        });
      });

      images.forEach(img => imageObserver.observe(img));
    }
  }

  /**
   * タブ切り替えのアニメーション強化（オプション）
   */
  function enhanceTabAnimation() {
    const tabInputs = document.querySelectorAll('input[name="merit-tabs"]');
    
    tabInputs.forEach(input => {
      input.addEventListener('change', function() {
        // タブ切り替え時の追加アニメーションをここに記述可能
        console.log('Tab changed to:', this.id);
      });
    });
  }

})();
